import React, { useState } from 'react';
import style from './verify.module.css';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { verifyTwoFA } from '../../actions/user.action';

const VerifyTwoFA = () => {
  const dispatch = useDispatch();
  const [code, setCode] = useState('');

  const handleSubmit = async () => {
    const secret = localStorage.getItem('xyz');
    dispatch(verifyTwoFA(secret, code));
  };

  return (
    <div className={style.Reset}>
      <p>Two Factor Authentication</p>
      <div className={style.details}>
        <p>Enter the verification code.</p>
      </div>
      <div className={style.section}>
        <p>Code</p>
        <input
          value={code}
          onChange={(e) => setCode(e.target.value)}
          type='text'
          placeholder='000000'
        />
      </div>
      <div onClick={handleSubmit} className={style.Button}>
        Verify
      </div>

      <div className={style.Bottom}>
        <span>Back to login page.</span>
        <Link
          to='/login'
          className='link'
          style={{ color: 'rgb(161, 35, 161)' }}
        >
          {' '}
          Log in.
        </Link>
      </div>
    </div>
  );
};

export default VerifyTwoFA;
